import { useEffect, useState } from "react";
import { useTypedSelector } from "../../../hooks/useTypedSelector";
import { Suppliers } from "../../profile/Suppliers";

export const SettingsSuppliers = () => {

  const { suppliers } = useTypedSelector(state => state.auth);

  const [active, setActive] = useState<number>(0)

    useEffect(() => {
      if( suppliers.length > 1 ){
        setActive(1)
      }
    }, [suppliers])

  return (
    <div>
      <h3 className="tw-mb-4">Suppliers</h3>
      <div className="flex flex-gap border-b pb-1 mb-1 suppliers-btns">
        {
          suppliers.length > 0 &&
          suppliers.map((supplier, index) => (
            <button
              key={supplier.id}
              onClick={() => setActive(index)}
              className={`supplier-btn ${active === index ? "active" : ""} flex flex-gap`}>
              {supplier.name}
              <div className={`supplier-count font-xsmall ${active === index && "active"}`}>{supplier.suppliers.length}</div>
            </button>
          ))
        }
      </div>

      {
        suppliers[active] &&
        <Suppliers suppliers={suppliers[active]} />
      }
    </div>
  )
}
